import {
	endpointsMap,
	IGetRefinementImagesOptions,
	IGetRefinementImagesResponse
} from './ICustomShopperRefinementImages';

import AbstractCustomShopperAPI from '../AbstractCustomShopperAPI';
import {ICustomApiConfig} from '../ICustomApiConfig';

/**
 * Represents CustomShopperRefinementImages
 */
class CustomShopperRefinementImages extends AbstractCustomShopperAPI {
	/**
	 * @constructor
	 * @param {ICustomApiConfig} config - API Config
	 */
	constructor(config: ICustomApiConfig) {
		super(config);
	}

	/**
	 * Retrieves refinement image URLs for given presentation IDs
	 * @param {IGetRefinementImagesOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {IGetRefinementImagesResponse} - Refinement images response
	 */
	public async getRefinementImages(
		fetchOptions: IGetRefinementImagesOptions,
		throwOnError?: boolean
	): Promise<IGetRefinementImagesResponse> {
		const response = await this.callCustomEndpoint<IGetRefinementImagesResponse>(
			fetchOptions,
			endpointsMap.GET_REFINEMENT_IMAGES
		);

		if (throwOnError && response.detail) {
			throw new Error(response.detail);
		}

		return response;
	}
}

export default CustomShopperRefinementImages;
